var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Toast_instances, _Toast_rootElem, _Toast_messages, _Toast_defaultDuration, _Toast_defaultMaxNumOfMessages, _Toast_closeMessage, _Toast_autoCloseMessage, _Toast_hasReachedMaximum, _Toast_dequeueOldestMessage;
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { nanoid } from 'nanoid';
import { render } from 'react-dom';
import Toasts from './Toasts';
const positions = [
    'topLeft',
    'topRight',
    'topCenter',
    'bottomLeft',
    'bottomRight',
    'bottomCenter'
];
export default class Toast {
    constructor(rootElement) {
        _Toast_instances.add(this);
        _Toast_rootElem.set(this, void 0);
        _Toast_messages.set(this, void 0);
        _Toast_defaultDuration.set(this, void 0);
        _Toast_defaultMaxNumOfMessages.set(this, void 0);
        if (!rootElement)
            throw new Error('Toast root element does not exist');
        __classPrivateFieldSet(this, _Toast_rootElem, rootElement, "f");
        __classPrivateFieldSet(this, _Toast_defaultDuration, 3000, "f");
        __classPrivateFieldSet(this, _Toast_messages, new Map(positions.map(position => [position, []])), "f");
        __classPrivateFieldSet(this, _Toast_defaultMaxNumOfMessages, 0, "f");
    }
    success({ message, position = 'topLeft', duration = __classPrivateFieldGet(this, _Toast_defaultDuration, "f"), maxNumOfMessages = __classPrivateFieldGet(this, _Toast_defaultMaxNumOfMessages, "f") }) {
        if (__classPrivateFieldGet(this, _Toast_instances, "m", _Toast_hasReachedMaximum).call(this, position, maxNumOfMessages))
            __classPrivateFieldGet(this, _Toast_instances, "m", _Toast_dequeueOldestMessage).call(this, position);
        const id = nanoid();
        __classPrivateFieldGet(this, _Toast_messages, "f").get(position).push({
            id,
            message,
            type: 'success',
            duration
        });
        render(_jsx(_Fragment, { children: positions.map(pos => (_jsx(Toasts, { position: pos, messages: __classPrivateFieldGet(this, _Toast_messages, "f").get(pos), closeMessage: __classPrivateFieldGet(this, _Toast_instances, "m", _Toast_closeMessage).bind(this) }, pos))) }), __classPrivateFieldGet(this, _Toast_rootElem, "f"));
        __classPrivateFieldGet(this, _Toast_instances, "m", _Toast_autoCloseMessage).call(this, duration, position, id);
    }
    warning({ message, position = 'topLeft', duration = __classPrivateFieldGet(this, _Toast_defaultDuration, "f"), maxNumOfMessages = __classPrivateFieldGet(this, _Toast_defaultMaxNumOfMessages, "f") }) {
        if (__classPrivateFieldGet(this, _Toast_instances, "m", _Toast_hasReachedMaximum).call(this, position, maxNumOfMessages))
            __classPrivateFieldGet(this, _Toast_instances, "m", _Toast_dequeueOldestMessage).call(this, position);
        const id = nanoid();
        __classPrivateFieldGet(this, _Toast_messages, "f").get(position).push({
            id,
            message,
            type: 'warning',
            duration
        });
        render(_jsx(_Fragment, { children: positions.map(pos => (_jsx(Toasts, { position: pos, messages: __classPrivateFieldGet(this, _Toast_messages, "f").get(pos), closeMessage: __classPrivateFieldGet(this, _Toast_instances, "m", _Toast_closeMessage).bind(this) }, pos))) }), __classPrivateFieldGet(this, _Toast_rootElem, "f"));
        __classPrivateFieldGet(this, _Toast_instances, "m", _Toast_autoCloseMessage).call(this, duration, position, id);
    }
    error({ message, position = 'topLeft', duration = __classPrivateFieldGet(this, _Toast_defaultDuration, "f"), maxNumOfMessages = __classPrivateFieldGet(this, _Toast_defaultMaxNumOfMessages, "f") }) {
        if (__classPrivateFieldGet(this, _Toast_instances, "m", _Toast_hasReachedMaximum).call(this, position, maxNumOfMessages))
            __classPrivateFieldGet(this, _Toast_instances, "m", _Toast_dequeueOldestMessage).call(this, position);
        const id = nanoid();
        __classPrivateFieldGet(this, _Toast_messages, "f").get(position).push({
            id,
            message,
            type: 'error',
            duration
        });
        render(_jsx(_Fragment, { children: positions.map(pos => (_jsx(Toasts, { position: pos, messages: __classPrivateFieldGet(this, _Toast_messages, "f").get(pos), closeMessage: __classPrivateFieldGet(this, _Toast_instances, "m", _Toast_closeMessage).bind(this) }, pos))) }), __classPrivateFieldGet(this, _Toast_rootElem, "f"));
        __classPrivateFieldGet(this, _Toast_instances, "m", _Toast_autoCloseMessage).call(this, duration, position, id);
    }
    info({ message, position = 'topLeft', duration = __classPrivateFieldGet(this, _Toast_defaultDuration, "f"), maxNumOfMessages = __classPrivateFieldGet(this, _Toast_defaultMaxNumOfMessages, "f") }) {
        if (__classPrivateFieldGet(this, _Toast_instances, "m", _Toast_hasReachedMaximum).call(this, position, maxNumOfMessages))
            __classPrivateFieldGet(this, _Toast_instances, "m", _Toast_dequeueOldestMessage).call(this, position);
        const id = nanoid();
        __classPrivateFieldGet(this, _Toast_messages, "f").get(position).push({
            id,
            message,
            type: 'info',
            duration
        });
        render(_jsx(_Fragment, { children: positions.map(pos => (_jsx(Toasts, { position: pos, messages: __classPrivateFieldGet(this, _Toast_messages, "f").get(pos), closeMessage: __classPrivateFieldGet(this, _Toast_instances, "m", _Toast_closeMessage).bind(this) }, pos))) }), __classPrivateFieldGet(this, _Toast_rootElem, "f"));
        __classPrivateFieldGet(this, _Toast_instances, "m", _Toast_autoCloseMessage).call(this, duration, position, id);
    }
}
_Toast_rootElem = new WeakMap(), _Toast_messages = new WeakMap(), _Toast_defaultDuration = new WeakMap(), _Toast_defaultMaxNumOfMessages = new WeakMap(), _Toast_instances = new WeakSet(), _Toast_closeMessage = function _Toast_closeMessage(idToDelete, position) {
    const indexToDelete = __classPrivateFieldGet(this, _Toast_messages, "f").get(position).findIndex(({ id }) => id === idToDelete);
    if (indexToDelete === -1)
        return;
    __classPrivateFieldGet(this, _Toast_messages, "f").get(position).splice(indexToDelete, 1);
    render(_jsx(_Fragment, { children: positions.map(pos => (_jsx(Toasts, { position: pos, messages: __classPrivateFieldGet(this, _Toast_messages, "f").get(pos), closeMessage: __classPrivateFieldGet(this, _Toast_instances, "m", _Toast_closeMessage).bind(this) }, pos))) }), __classPrivateFieldGet(this, _Toast_rootElem, "f"));
}, _Toast_autoCloseMessage = function _Toast_autoCloseMessage(duration, position, id) {
    setTimeout(() => {
        __classPrivateFieldGet(this, _Toast_instances, "m", _Toast_closeMessage).call(this, id, position);
    }, duration, this);
}, _Toast_hasReachedMaximum = function _Toast_hasReachedMaximum(position, maxNumOfMessages) {
    if (maxNumOfMessages <= 0)
        return false;
    return __classPrivateFieldGet(this, _Toast_messages, "f").get(position).length >= maxNumOfMessages;
}, _Toast_dequeueOldestMessage = function _Toast_dequeueOldestMessage(position) {
    __classPrivateFieldGet(this, _Toast_messages, "f").get(position).shift();
};
